<template>
    <b-tabs pills card vertical class="">
        <b-tab title-link-class="" :key="idx"  :active="day.is_active"  v-for="(day,idx) in days">
            <template slot="title">
                <div class="fs-lg px-4 text-center ">
                    {{day.name }}
                </div>
            </template>

            <b-card-text>
                <component v-bind:is="day_component" :times="day.times" :cur_idx="idx"></component>
            </b-card-text>
        </b-tab>
    </b-tabs>

</template>

<script>
    import day from "./day";
    export default {
        name: "times",
        props : {
            times : {
                type: Array,
            }
        },

        data() {
            return {
                days :  [
                    {
                        'name' : this.__t('sun'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' :  this.__t('mon'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' :  this.__t('tue'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' :  this.__t('wed'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' :  this.__t('thurs'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' :  this.__t('fri'),
                        'is_active' : false,
                        'times' : [],
                    },
                    {
                        'name' : this.__t('sat'),
                        'is_active' : false,
                        'times' : [],
                    },
                ]
            }
        },

        components : {
            day
        },

        created () {
            this.push_rest_times();
        },

        methods : {
            push_rest_times() {
                if(this.times.length > 0) {
                    this.days.map((day,idx) => {
                        if(this.times.hasOwnProperty(idx)) {
                            let n_day = day;
                            n_day.times = this.times[idx];
                            Vue.set(this.days, idx, n_day);
                        }
                    })
                }
            },
        },

        computed : {
            day_component () {
                return 'day';
            },

        }
    }
</script>

<style scoped>

</style>
